export default __webpack_public_path__ + "static/media/TY22_SDCF_F8937_Common - Investors.d889d79e.pdf";